// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import NodeViewModel from "./../factories/node-view-model";
import ChildTabViewModel from "./../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../factories/tab-page";
import BaoDialogViewModel from "./../factories/bao-dialog";
import baoRouter from "./../services/bao-router";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../bindings/bao-searcher";
import "./../bindings/bao-toolbar2";
import "./../bindings/sorting";
import "./../bindings/bao-number-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import AppTabController from "../services/app-tab-controller";

function TicketAssignmentTabModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(this, tabPage, parent);
    tabPage.ViewModel(self);
    self.Bao = Bao;
    self.Ticket = parent;
    self.IsReadonly = parent.IsReadonly;
    self.RefreshInProgress = ko.observable(false);
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.TicketAssignmentCollection = ko.observableArray([]);
    self.SelectedTicketAssignmentRow = ko.observable({});
    self.SelectedTicketAssignmentRow.subscribe(function () {
        setButtons();
    });
    self.ToolbarButtons = ko.observableArray([]);
    var setButtons = function () {
        ko.utils.arrayForEach(self.ToolbarButtons(), function (button: any) {
            if (parent.IsReadonly()) {
                switch (button.ActionKey()) {
                    case "TicketNewAssignment":
                    case "TicketAddAssignment":
                    case "TicketRemoveAssignment":
                        button.Enabled(false);
                        break;
                    case "TicketEditAssignment":
                        button.Enabled(!(self.SelectedTicketAssignmentRow() == null));
                        break;
                }
            }
            else {
                switch (button.ActionKey()) {
                    case "TicketEditAssignment":
                    case "TicketRemoveAssignment":
                        button.Enabled(!(self.SelectedTicketAssignmentRow() == null));
                        break;
                }
            }
        });
    };
    self.ToolbarButtons.subscribe(setButtons);
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "TicketNewAssignment":
                var newTab = new TabPage();
                newTab.Url("Ticket/Index");
                newTab.UrlData({
                    id: null,
                    assignedTicketId: self.Ticket.TicketId()
                });
                AppTabController.AddTab(newTab);
                break;
            case "TicketAddAssignment":
                self.AddTicketAssignmentItem();
                break;
            case "TicketEditAssignment":
                self.OpenTicket(self.SelectedTicketAssignmentRow());
                break;
            case "TicketRemoveAssignment":
                if (self.SelectedTicketAssignmentRow() != null) {
                    self.DeleteTicketAssignment(parent.TicketId(), self.SelectedTicketAssignmentRow().TicketAssignmentId);
                }
                break;
        }
    };
    self.Refresh = function () {
        tabPage.IsLoading(true);
        var def = $.Deferred();
        Bao.post("Ticket/ResetTicketAssignment", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(def.resolve);
        });
        return def.promise();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("Ticket/GetTicketAssignmentCollection", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: parent.TicketId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedTicketAssignmentRow(null);
            self.TotalRows(0);
            self.TicketAssignmentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TicketAssignmentCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    var _msgCancel = Bao.Session.GetMessage("msgCancel");
    var _msgOk = Bao.Session.GetMessage("msgOk");
    self.AddTicketAssignmentItem = function () { };
    self.SelectedTicket = ko.observable();
    self.SelectedTicket.subscribe(function () {
        if (self.SelectedTicket() != null) {
            self.AddTicketAssignment(self.SelectedTicket(), self.Ticket.TicketId());
        }
    });
    self.AddTicketAssignment = function (assignedTicketId, ticketId) {
        tabPage.IsLoading(true);
        Bao.post("Ticket/AddTicketAssignment", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            assignedTicketId: assignedTicketId,
            ticketId: ticketId
        }), function () {
            parent.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.DeleteTicketAssignment = function (ticketId, ticketAssignmentId) {
        self.RefreshInProgress(true);
        Bao.post("Ticket/DeleteTicketAssignment", JSON.stringify({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: ticketId,
            ticketAssignmentId: ticketAssignmentId
        }), function () {
            self.RefreshInProgress(false);
            parent.TabPage.DirtyFlag.setDirty();
            self.RefreshGrid();
        });
    };
    self.OpenTicket = function (item) {
        if (item != null && ko.utils.unwrapObservable(item.TicketId) != self.Ticket.TicketId()) {
            baoRouter.setHash(item.OpenUrl);
        }
    };
    self.Save = function (saveTime) {
        var def = $.Deferred();
        Bao.post("Ticket/SaveTicketAssignmentCollection", JSON.stringify(ko.map.toJS({
            sessionTabId: parent.TabPage.SessionTabId,
            ticketId: parent.TicketId,
            saveTime: saveTime
        })), function () {
            self.Refresh().then(def.resolve);
        });
        return def.promise();
    };
    self.init = function () {
        return self.RefreshGrid();
    };
}
export default TicketAssignmentTabModel;